import React from 'react';
import { CreditCard, BarChart3, Shield, Zap, Clock, Smartphone } from 'lucide-react';

const TerminalFeatures = () => {
  const features = [
    {
      icon: CreditCard,
      title: "Zero Processing Fees",
      description: "Eliminate card processing fees completely with compliant fee recovery technology."
    },
    {
      icon: BarChart3,
      title: "Advanced Reporting",
      description: "Real-time transaction reports, daily summaries, and detailed analytics at your fingertips."
    },
    {
      icon: Shield,
      title: "PCI Compliant",
      description: "Bank-level security with end-to-end encryption and PCI DSS compliance built in."
    },
    {
      icon: Zap,
      title: "Fast Transactions",
      description: "Process payments in seconds with reliable, high-speed connectivity."
    },
    {
      icon: Clock,
      title: "24/7 Support",
      description: "Round-the-clock customer support whenever you need assistance."
    },
    {
      icon: Smartphone,
      title: "Modern Interface",
      description: "Intuitive touchscreen terminals that are easy for staff to use from day one."
    }
  ];

  return (
    <section className="py-20" style={{ backgroundColor: '#0B1F3A' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium mb-6" style={{ backgroundColor: 'rgba(212, 175, 55, 0.2)', color: '#D4AF37' }}>
            <CreditCard size={16} />
            <span>Modern Payment Systems</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            More Than Just Payment Processing
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Our payment systems don't just save you money — they give you powerful tools to run your business smarter.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div 
                key={index}
                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-all duration-300 group"
              >
                <div 
                  className="w-14 h-14 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform"
                  style={{ backgroundColor: 'rgba(212, 175, 55, 0.2)' }}
                >
                  <IconComponent style={{ color: '#D4AF37' }} size={28} />
                </div>
                <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
                <p className="text-gray-400">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TerminalFeatures;
